export const initialData: any = {
  // tickets: {
  //   "ticket-1": { id: "ticket-1", content: "Ticket 1" },
  //   "ticket-2": { id: "ticket-2", content: "Ticket 2" },
  //   "ticket-3": { id: "ticket-3", content: "Ticket 3" },
  //   "ticket-4": { id: "ticket-4", content: "Ticket 4" },
  // },
  tickets: {},
  columns: {
    open: {
      id: "open",
      title: "Open Tickets",
      // ticketIds: ["ticket-1", "ticket-2"],
      ticketIds: [],
      color: "#006AB3",
    },
    "in-progress": {
      id: "in-progress",
      title: "In Progress",
      // ticketIds: ["ticket-4"],
      ticketIds: [],
      color: "#F4BD00",
    },
    closed: {
      id: "closed",
      title: "Closed",
      // ticketIds: ["ticket-3"],
      ticketIds: [],
      color: "#78BA2C",
    },
  },
  columnOrder: ["open", "in-progress", "closed"],
};

export const ticketStatus: {
  [key: string]: string;
} = {
  open: "open",
  progress: "in-progress",
  done: "closed",
};

export const ticketStatusConversion: {
  [key: string]: string;
} = {
  open: "open",
  "in-progress": "progress",
  closed: "done",
};
